import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const deleteCallLogNoteById = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    serviceCall({
      url: apiConstants.VIDEO.DELETE_CALL_LOG_NOTE_BY_ID,
      method: 'delete',
      data: data,
    })
      .then((response) => {
        callback && callback(response)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
